import { BindingError } from "../../BindingError.js";
class LocalizedBindingError extends BindingError {
  constructor(message, markerPath) {
    super(message);
    this.markerPath = markerPath;
  }
  nestedIn(wrapper) {
    return new LocalizedBindingError(this.message, [wrapper, ...this.markerPath]);
  }
}
export {
  LocalizedBindingError
};
//# sourceMappingURL=LocalizedBindingError.js.map
